import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { getSampleApp } from "../Actions/API/AppTemplate/Interface/TemplateInstantiateActions"
import { changeInputValue } from "../Actions/Client/InputRender/InputRenderActions"
import { APIAppTemplateModel } from "../Models/API/AppTemplateModel"
import { fromInputs } from "../Models/Client/JobSubmitData"
import { MainThunkDispatch } from "../Reducers"
import { useAppState } from "./useReduxState"

/**
 * This hooks prepare sample data to be used while onboarding if so selected by user
 * @param template APIAppTemplateModel
 * @returns true if sample data is loading else false
 */
export const useSampleAppData = (template: APIAppTemplateModel): boolean => {
    const dispatch = useDispatch<MainThunkDispatch>()

    const onboarding = useAppState(
        state => state.api.interface.templateInstantiate
    )
    const sampleAppData = useAppState(state =>
        onboarding?.selectedSampleAppIdentifier
            ? state.api.interface.templateInstantiate?.sampleAppDataEntries[
                  onboarding.selectedSampleAppIdentifier
              ]
            : undefined
    )
    const [loading, setLoading] = useState<boolean>(
        !!onboarding?.selectedSampleAppIdentifier
    )

    useEffect(() => {
        if (
            onboarding?.selectedSampleAppIdentifier !== undefined &&
            sampleAppData === undefined
        ) {
            dispatch(
                getSampleApp(
                    template.name,
                    onboarding.selectedSampleAppIdentifier
                )
            )
        } else if (
            sampleAppData !== undefined &&
            template.appParamsSchema !== null &&
            template.appParamsSchema.params !== null &&
            onboarding !== null
        ) {
            dispatch(
                changeInputValue(onboarding.paramsRenderId, {
                    values: { ...sampleAppData.appParams.params },
                    surviveReroute: true,
                    errors: []
                })
            )
            dispatch(
                changeInputValue(onboarding.inputDataRenderId, {
                    values: fromInputs(sampleAppData.dataInputs, false),
                    surviveReroute: true,
                    errors: []
                })
            )
            setLoading(false)
        }
    }, [
        dispatch,
        onboarding,
        sampleAppData,
        template.appParamsSchema,
        template.inputSchema,
        template.name
    ])

    return loading
}
